export function encodeName(name: string) {
  let encodedName = name;
  encodedName = encodedName.replace(/\?/g, encodeURIComponent('?'));
  encodedName = encodedName.replace(/\//g, encodeURIComponent('/'));
  encodedName = encodeURIComponent(encodedName);
  encodedName = encodedName.replace(/'/g, escape("'"));
  encodedName = encodedName.replace(/"/g, escape('"'));
  return encodedName;
}
